import { getConfig } from "@jti/fe-common";
import { getIsEvo, getUser } from "../../utils";
import { TssApiEvo } from "./TssApiEvo";
import { TssApiLegacy } from "./TssApiLegacy";
export class TssApi {
    constructor() {
        this.name = "TssApi";
    }
    static init() {
        const config = getConfig();
        const user = getUser();
        if (getIsEvo(config.TSS_URL)) {
            return new TssApiEvo(config.TSS_URL, config.TSS_TOKEN, user.ciam_token);
        }
        return new TssApiLegacy(config.TSS_URL, config.TSS_TOKEN, user.ciam_token);
    }
}
//# sourceMappingURL=TssApi.js.map